import { gl } from './context.js'
import { canvas } from './context.js'
import * as glm from 'gl-matrix'

var lastTime = 0;
var delta = 0.000001;

var scene = {
  projectionMatrix: glm.mat4.create(),
  viewMatrix: glm.mat4.create(),
  rotateM: glm.mat4.create(),
  models: []
};

var mouse = {
  x: 0.75,
  y: 0.5,
};

function Update(delta) {
  var rotateTempM = glm.mat4.create();
  glm.mat4.rotateY(rotateTempM, rotateTempM, mouse.x * mouse.x * mouse.x * 0.05 * delta);
  glm.mat4.rotateX(rotateTempM, rotateTempM, -mouse.y * mouse.y * mouse.y * 0.05 * delta);
  glm.mat4.multiply(scene.rotateM, rotateTempM, scene.rotateM);
  glm.mat4.lookAt(scene.viewMatrix, [mouse.x * 2, mouse.y * 1, -50.0], [0.0, 0.0, 0.0], [0.0, 1.0, 0.0]);
  glm.mat4.multiply(scene.viewMatrix, scene.viewMatrix, scene.rotateM);

  for (var i = 0; i < scene.models.length; i++) {
    scene.models[i].Update(delta);
  }
}

function Draw() {
  gl.clear(gl.COLOR_BUFFER_BIT);

  scene.models.Draw(scene);
}

// update and draw the scene
function Loop(timestamp) {
  // next frame
  requestAnimationFrame(Loop);

  // timer
  delta = (timestamp - lastTime) / 1000.0;
  lastTime = timestamp;

  // element resize
  Resize();

  // update
  Update(delta);

  // draw
  Draw();
}

function Resize() {
  // retina
  var dpp = window.devicePixelRatio || 1;

  var displayWidth  = Math.floor(canvas.clientWidth  * dpp);
  var displayHeight = Math.floor(canvas.clientHeight * dpp);

  // is resize needed?
  if (gl.canvas.width  !== displayWidth || gl.canvas.height !== displayHeight) {
    // canvas
    gl.canvas.width  = displayWidth;
    gl.canvas.height = displayHeight;

    // viewport
    gl.viewport(0, 0, canvas.width, canvas.height);

    // projection matrix - fov 45°
    glm.mat4.perspective(scene.projectionMatrix, 0.785, canvas.width / canvas.height, 1.0, 1000.0);
  }
}

function Clamp(a) {
  a = a > 1 ? 1 : a;
  a = a < -1 ? -1 : a;
  return a;
}

function MouseMove(event) {
  mouse.x = Clamp((event.clientX / gl.canvas.width - 0.5) * 2);
  mouse.y = Clamp((event.clientY / gl.canvas.height - 0.5) * 2);
}

function InitGl() {
  // clear
  gl.clearColor(0.0, 0.0, 0.0, 0.0);
  gl.clearDepth(1.0);

  // depth
  gl.disable(gl.DEPTH_TEST);

  // blend
  gl.enable(gl.BLEND);
  gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
}

function Renderer(models) {
  scene.models = models;

  // matrices
  glm.mat4.perspective(scene.projectionMatrix, 0.785, canvas.width / canvas.height, 0.1, 100.0);
  glm.mat4.lookAt(scene.viewMatrix, [-35.0, -65.0, 20.0], [0.0, 0.0, 10.0], [0.0, 0.0, 1.0]);

  // events
  document.addEventListener('mousemove', MouseMove);

  // element resize
  Resize();

  // init GL state
  InitGl();

  // start the loop
  requestAnimationFrame(Loop);
}

export { Renderer }
